import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'

export async function signUp(
  payload: {
    email: string
    password: string
    name: string
  },
  token: string,
) {
  return usersApi.post(apiRoutes.signup, payload, {
    headers: { Authorization: `Bearer ${token}` },
  })
}
